enum ProductTrackingNames {
  perks = "perks",
  recognition = "recognition",
  medical = "medical",
  wellness = "wellness",
  home = "home",
  wallet = "wallet",
  account = "my account",
  rewards = "rewards"
}

export default ProductTrackingNames
